(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["variant-main-picker"] && !Shopify.designMode) return;
  try {
    document.addEventListener('change', (event) => {
    const menu = event.target.closest?.('.mf-option-menu');
    if (!menu) return;
    menu.removeAttribute('open');
    const selected = menu.querySelector('.mf-option-summary strong');
    if (selected) selected.textContent = event.target.value;
    const preview = menu.querySelector('.mf-option-preview');
    const image = event.target.closest('label')?.querySelector('.mf-option-image');
    if (preview && image) { preview.src = image.src; preview.srcset = image.srcset; preview.alt = image.alt; }
    menu.querySelector('summary')?.focus({preventScroll:true});
  });
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    const menu = event.target.closest?.('.mf-option-menu');
    if (menu) { menu.removeAttribute('open'); menu.querySelector('summary')?.focus(); }
  });
  } catch(e) { console.error(e); }
})();

})();
